import firebase from 'firebase/app';
import 'firebase/firestore';

// const firebaseConfig = {
//   apiKey: 'AIzaSyBvgprMUP9WiYnFOT1jH47yIP1oxkMaFL8',
//   authDomain: 'leads-llama.firebaseapp.com',
//   projectId: 'leads-llama',
//   storageBucket: 'leads-llama.appspot.com',
//   messagingSenderId: '577162576557',
//   appId: '1:577162576557:web:b508917dbe3f0046747c24',
//   measurementId: 'G-GR1MM9TF6R'
// };

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDV9RpewKZo3FuSUMXbkRDJzsS5CgNJ5vo",
  authDomain: "leadsllama.firebaseapp.com",
  projectId: "leadsllama",
  storageBucket: "leadsllama.appspot.com",
  messagingSenderId: "1088820827429",
  appId: "1:1088820827429:web:aad3d866cc43e8e00076cc",
  measurementId: "G-DFZMM9GQKS"
};

const FirebaseApp = firebase.initializeApp(firebaseConfig);

export const Collections = {
  Events: 'Events',
  Leads: 'Leads',
  ZohoForms: "ZohoForms"
};

export default FirebaseApp;
